"use client";

import type React from "react";
import { useState } from "react";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonLabel,
  IonAlert,
  IonBackButton,
  IonButtons,
} from "@ionic/react";
import { Box, TextField, IconButton } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { createJobsQuestion } from "../../../api/jobs/jobs";

interface QuestionData {
  job_id: string;
  question_id?: string;
  question: string;
  answer: string;
  options: string[];
}

interface CreateQuestionFormProps {
  jobId: string;
  onSuccess?: () => void;
  onClose: () => void; // Added onClose prop for modal control
}

const CreateQuestionForm: React.FC<CreateQuestionFormProps> = ({
  jobId,
  onSuccess,
  onClose,
}) => {
  const [questionData, setQuestionData] = useState<QuestionData>({
    job_id: jobId,
    question: "",
    answer: "",
    options: ["", ""],
  });
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  // console.log(questionData)
  const handleInputChange = (field: keyof QuestionData, value: string) => {
    setQuestionData((prev) => ({ ...prev, [field]: value }));
  };

  const handleOptionChange = (index: number, value: string) => {
    const newOptions = [...questionData.options];
    newOptions[index] = value;
    setQuestionData((prev) => ({ ...prev, options: newOptions }));
  };

  const addOption = () => {
    setQuestionData((prev) => ({ ...prev, options: [...prev.options, ""] }));
  };

  const removeOption = (index: number) => {
    if (questionData.options.length <= 2) {
      setError("At least two options are required");
      return;
    }
    const newOptions = [...questionData.options];
    newOptions.splice(index, 1);
    setQuestionData((prev) => ({ ...prev, options: newOptions }));
  };

  const handleSubmit = async () => {
    // Validation


    // if (!questionData.question.trim()) {
    //   setError("Question is required");
    //   return;
    // }
    // if (!questionData.answer.trim()) {
    //   setError("Answer is required");
    //   return;
    // }
    // if (questionData.options.filter((opt) => opt.trim()).length < 2) {
    //   setError("At least two options are required");
    //   return;
    // }
    // if (!questionData.options.includes(questionData.answer)) {
    //   setError("Correct answer must be one of the provided options.");
    //   return;
    // }

    try {
      // Call your API here


    console.log('hey')

      console.log("Submitting question data:", questionData);

      const response = await createJobsQuestion(questionData);
      console.log("Question created successfully:", response);

      setSuccess(true);
      setQuestionData({
        job_id: jobId,
        question: "",
        answer: "",
        options: ["", ""],
      });

      if (onSuccess) onSuccess();
      onClose(); // Close the modal on success
    } catch (err) {
      setError("Failed to create question: " + (err as Error).message);
    }
  };

  return (
    <>
      <Box sx={{ p: 2 }}>
        <TextField
          label="Question"
          fullWidth // Corrected from fullwidth
          multiline
          rows={3}
          variant="outlined"
          value={questionData.question}
          onChange={(e) => handleInputChange("question", e.target.value)}
          sx={{ mb: 3 }}
        />

        <Box sx={{ mb: 3 }}>
          <IonLabel>Options</IonLabel>
          {questionData.options.map((option, index) => (
            <Box
              key={index}
              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
            >
              <TextField
                fullWidth // Corrected from fullwidth
                variant="outlined"
                placeholder={`Option ${index + 1}`}
                value={option}
                onChange={(e) => handleOptionChange(index, e.target.value)}
              />
              <IconButton
                color="error"
                onClick={() => removeOption(index)}
                disabled={questionData.options.length <= 2}
              >
                <Delete />
              </IconButton>
              {index === questionData.options.length - 1 && (
                <IconButton color="primary" onClick={addOption}>
                  <Add />
                </IconButton>
              )}
            </Box>
          ))}
        </Box>

        <TextField
          label="Correct Answer"
          fullWidth // Corrected from fullwidth
          variant="outlined"
          value={questionData.answer}
          onChange={(e) => handleInputChange("answer", e.target.value)}
          sx={{ mb: 3 }}
        />

        <IonButton expand="block" onClick={handleSubmit}>
          Save Question
        </IonButton>
      </Box>

      <IonAlert
        isOpen={!!error}
        onDidDismiss={() => setError(null)}
        header="Error"
        message={error || ""}
        buttons={["OK"]}
      />

      <IonAlert
        isOpen={success}
        onDidDismiss={() => setSuccess(false)}
        header="Success"
        message="Question created successfully!"
        buttons={["OK"]}
      />
    </>
  );
};

export default CreateQuestionForm;
